import { IDocumentModel, Nullable } from "../types";

export interface IDocument {
    DocumentId: Nullable<number>,
    DocumentName: string,
    Signature: string,
    Thumbprint: string,
    OrganizerSignStatus: number,
    WinnerSignStatus: number,
    WinnerCanSign: boolean,
    OrganizerCanSign: boolean,
    SignStatusDescription: string,
    DataToSign: string,
    IsOrganizer: boolean
    Document: IDocumentModel
}

export enum SignStatusses {
    CorrectSign = 1,
    CorruptedSign = 2,
    CorruptedFile = 3,
    MissingFile = 4,
    SignDontCorrespondFile = 5,
    SuccessProtocolPartiallySigned = 6
}

export var SignStatusesDescription: { [key: SignStatusses]: string; } = {};
SignStatusesDescription[SignStatusses.CorrectSign] = "Подпись корректная";
SignStatusesDescription[SignStatusses.CorruptedSign] = "Подпись повреждена";
SignStatusesDescription[SignStatusses.CorruptedFile] = "Повреждён файл";
SignStatusesDescription[SignStatusses.MissingFile] = "Отсутствует файл";
SignStatusesDescription[SignStatusses.SignDontCorrespondFile] = "Подпись не соответствует файлу";
SignStatusesDescription[SignStatusses.SuccessProtocolPartiallySigned] = "Протокол подписан только организатором или победителем";

